import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
    Animated,
    Dimensions,
    Image,
    StyleSheet,
    Text,
    TouchableOpacity,
    View,
} from 'react-native'
import MapView, { Marker } from 'react-native-maps'
import { PROVIDER_GOOGLE } from 'react-native-maps'
import { getLocation } from '../appBar/context/LocationContext'
import { useFocusEffect, useNavigation } from '@react-navigation/native'
import { Feather } from '@expo/vector-icons'
import { schedulesServices } from '../../../database/schedules.database'
import { distanceInMeters } from '../customUtils/calculateDistance'
import { StoreItem } from './StoreItem'
import { CampaignStatus } from './StatusTagsStores'
import theme from '../../../theme'
import styles from './MapScreenStyles'
import { Loader, LoaderImage } from '../customUtils/Components/Loader'
import { STORE_STATUS } from './constants/constants.stores'
import { sleep } from '@/utils/functions.utils'
import debounce from 'lodash/debounce'
import { UpdateLocationIcon } from '../navigation/UpdateLocationIcon'

const width = Dimensions.get('window').width
const height = Dimensions.get('window').height
export const MapScreen = ({ route }) => {
    const { userLat, userLng, setUserLat, setUserLng } = getLocation()
    const { selectedScheduleID, campaign_schedule_free, campaignSteps } =
        route.params

    const stores = useRef(null)
    const [regionFilteredStores, setRegionFilteredStores] = useState([])

    const markers = useRef(null)
    const [regionFilteredMarkers, setRegionFilteredMarkers] = useState([])
    // const visibleMarkers = useRef(null)
    const [visibleMarkers, setVisibleMarkers] = useState([])

    const navigation = useNavigation()
    const [currentStore, setCurrentStore] = useState(null)
    const scrollX = useRef(new Animated.Value(0)).current
    const deviceWidth = Dimensions.get('window').width
    const [currentIndex, setCurrentIndex] = useState(0)
    const mainViewRef = useRef(null)

    const [isLoading, setisLoading] = useState(true)
    const mapRef = useRef(null)
    const hasLoadedStores = useRef(false) // ✅ Prevenir múltiples cargas
    const isUpdatingMarkers = useRef(false) // ✅ Prevenir actualizaciones concurrentes
    const updateTimeout = useRef(null) // ✅ Para debounce
    const isAnimatingCamera = useRef(false) // ✅ Prevenir animaciones concurrentes
    const viewChangeTimeout = useRef(null) // ✅ Debounce para cambios de vista

    const hasCompletedInitialLoad = useRef(false) // ✅ Flag para saber si ya cargó inicial
    const lastCamera = useRef(null)
    const [cameraChangedTrigger, setCameraChangedTrigger] = useState(0)
    let initialCamera = {
        center: {
            latitude: userLat,
            longitude: userLng,
        },
        heading: 0,
        pitch: 0,
        zoom: 16,
    }

    const lastFilterCenter = useRef({ lat: userLat, lng: userLng })
    const lastFilterRadiusKm = useRef(null)
    const [currentStoreID, setCurrentStoreID] = useState(null)

    useFocusEffect(
        useCallback(() => {
            console.log('🔵 [useFocusEffect] Ejecutando getStores()')
            getStores()

            return () => {
                console.log('🔴 [useFocusEffect cleanup]')
                setisLoading(true)

                if (updateTimeout.current) {
                    clearTimeout(updateTimeout.current)
                }

                if (viewChangeTimeout.current) {
                    clearTimeout(viewChangeTimeout.current)
                }
            }
        }, []),
    )

    const getStores = async (lat = userLat, lng = userLng) => {
        console.log('====================================')
        console.log('estoy en el get stores del mapaaa')
        console.log('====================================')
        try {
            const allStores = await schedulesServices.getStoresFromSchedule(
                0,
                0,
                selectedScheduleID,
                -1,
                lat,
                lng,
                5000,
                campaign_schedule_free,
            )

            console.log('✅ [getStores] Tiendas obtenidas:', allStores?.length)

            if (!allStores || allStores.length === 0) {
                console.warn('⚠️ [getStores] No hay tiendas')
                stores.current = []
                markers.current = []
                setisLoading(false)
                return
            }
            // Stores from nearest 10km

            allStores.forEach((store) => {
                store.distance = distanceInMeters(
                    userLat,
                    userLng,
                    store.lat,
                    store.lng,
                )
            })
            // console.log('ALL', allStores.length)

            let updatedMarkers = allStores.map((store) => {
                return {
                    _id: store._id,
                    lat: store.lat,
                    lng: store.lng,
                    name: store.name,
                    color: getColorPin(store.campaign_status ?? 0),
                    status: store.campaign_status,
                    incidence_answer: store.incidence_answer,
                }
            })

            console.log('📍 [getStores] Seteando stores y markers...')
            stores.current = allStores
            markers.current = updatedMarkers
            console.log('ALL STORES FETCH', allStores.length)
            await filterStoresPerKm(userLat, userLng, null, 5)
            sleep(2000)

            isUpdatingMarkers.current = false
            isAnimatingCamera.current = false
            hasCompletedInitialLoad.current = true // ✅ Marcar que ya cargó inicial

            setisLoading(false)
        } catch (error) {
            console.error('❌ [getStores] Error:', error)
            console.error('❌ [getStores] Stack:', error?.stack)
            stores.current = []
            markers.current = []
            setisLoading(false)
        } finally {
            setisLoading(false)
        }
    }

    const filterStoresPerKm = async (lat, lng, radiusKm = 5) => {
        console.log('Stores all lenght ', stores.current.length)
        const nearestStores = getNearestStores(stores.current, lat, lng, {
            radiusKm: 5,
            minStores: 30,
            maxRadiusKm: 20,
        })
        console.log('Neares Stores. =>', nearestStores.length)
        if (nearestStores.length === 0) return
        setRegionFilteredStores(nearestStores)

        const filtered_ids = nearestStores.map((s) => s._id)
        const nearestMarkers = markers.current.filter((m) =>
            filtered_ids.includes(m._id),
        )
        setRegionFilteredMarkers(nearestMarkers)
    }
    const onClickGoStore = (store) => {
        navigation.navigate('StoreDetail', {
            storeID: store._id,
            forms: store.forms,
            scheduleID: selectedScheduleID,
            steps: campaignSteps,
            forms_relevant: store.forms_relevant,
            forms_advances: store.forms_advances,
            distance: store.distance ?? 0,
            store_status: store.campaign_status,
            incidence_answer: store.incidence_answer,
        })
    }

    const getItemLayout = (data, index) => ({
        length: deviceWidth,
        offset: deviceWidth * index,
        index,
    })

    const goToAddStores = () => {
        navigation.navigate('AddStores')
    }
    const onItemViewedChange = useCallback((data) => {
        const item = data?.changed[0]?.item
        console.log('Cambio item tarjeta')
        if (!item) return

        if (updateTimeout.current) {
            clearTimeout(updateTimeout.current)
        }

        const newCamera = {
            center: {
                latitude: item.lat,
                longitude: item.lng,
            },
            heading: 0,
            pitch: 0,
            zoom: 16,
        }

        setCameraChangedTrigger((t) => t + 1)
        setCurrentStoreID(item._id ?? null)
        // setCurrentStore(newCamera)
        mapRef.current?.animateCamera(newCamera, { duration: 250 })
    }, [])
    const COLOR_BLACK = theme.colors.colorPending
    const COLOR_RED = 'red'

    const getColorPin = (status) => {
        switch (status) {
            case CampaignStatus.STATUS_FORM_PENDING:
                return theme.colors.colorPending
            case CampaignStatus.STATUS_FORM_APPROVED:
                return theme.colors.colorApproved
            case CampaignStatus.STATUS_FORM_PENDING_MODERATION:
                return '#ff002f'
            case CampaignStatus.STATUS_FORM_REFUSED:
                return '#ff002f'
            case CampaignStatus.STATUS_FORM_IN_PROGRESS:
                return '#0000ff'
            case CampaignStatus.STATUS_FORM_PENDING_SYNC:
                return '#ffffff'
            case STORE_STATUS.INCIDENCE_REPORTED_CLOSE:
                return COLOR_BLACK
            case STORE_STATUS.INCIDENCE_REPORTED:
                return COLOR_RED
            case STORE_STATUS.INCIDENCE_REPORTED_PERMANENTE:
                return COLOR_RED
            default:
                return null
        }
    }
    useEffect(() => {
        const listener = scrollX.addListener(({ value }) => {
            const index = Math.round(value / deviceWidth)
            setCurrentIndex(index)
        })

        return () => {
            scrollX.removeAllListeners()
            // listener.remove()
        }
    }, [])

    const handleCameraChange = async (camera) => {
        lastCamera.current = camera

        setCameraChangedTrigger((t) => t + 1)
        onCameraIdle(camera)
        return
    }
    const mapDimensions = { width: width, height: height }

    const updateVisibleMarkers = async (mapDimensions) => {
        try {
            if (isCalculating.current) {
                pendingRecalc.current = true
                return
            }

            isCalculating.current = true
            pendingRecalc.current = false

            const camera = lastCamera.current
            console.log('CAMERA  ===>', camera)

            const center = camera.center
            const zoom = camera.zoom
            const bounds = calculateBounds(center, zoom, mapDimensions)
            // const visibleStores = regionFilteredStores.filter((store) => isMarkerInBounds(store.lat, store.lng, bounds)).slice(0, 30)
            const updatedMarkers = regionFilteredMarkers
                .filter((store) => isMarkerInBounds(store.lat, store.lng, bounds))
                .slice(0, 30)

            // const filteredMarkers = getNearestStores(markers, userLat, userLng, bounds)
            setVisibleMarkers(updatedMarkers)
            // visibleMarkers.current = updatedMarkers
            // setVisibleStores(visibleStores)
        } catch (error) {
            console.error('❌ [updateVisibleMarkers] Error:', error)
        } finally {
            isCalculating.current = false

            // si llegó otro evento mientras calculaba → ejecutar de nuevo
            if (pendingRecalc.current) {
                pendingRecalc.current = false
                //  runRecalculateMarkers()
            }
        }
    }

    const debounceTimer = useRef(null) // espera los 2s
    const isCalculating = useRef(false) // si está procesando
    const pendingRecalc = useRef(false) // si llegó un nuevo evento mientras recalcula

    // useEffect(() => {
    //     if (!lastCamera) return
    //     console.log('Espero')
    //     const t = setTimeout(() => {
    //         console.log('llamo')
    //         setDebouncedCamera(lastCamera)
    //     }, 50)

    //     return () => clearTimeout(t)
    // }, [lastCamera])

    useEffect(() => {
        if (isLoading) return

        // 1) cancelar el timer previo
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current)
            debounceTimer.current = null
        }

        // 2) si estamos calculando → marcar que hay una actualización pendiente
        if (isCalculating.current) {
            pendingRecalc.current = true
            return
        }
        // 3) iniciar nuevo timer de 2s
        debounceTimer.current = setTimeout(() => {
            updateVisibleMarkers(mapDimensions)
        }, 400)
    }, [cameraChangedTrigger])
    const lastCenter = useRef(null)
    const onCameraIdle = useCallback((region) => {
        debouncedCheckForRecalculation(region.center)
    }, [])
    const checkIfNeedsRecalculation = (cameraCenter) => {
        if (!lastCenter.current) {
            lastCenter.current = cameraCenter
            return true // primera vez, siempre recalculo
        }

        const movedKm = haversine(
            lastCenter.current.latitude,
            lastCenter.current.longitude,
            cameraCenter.latitude,
            cameraCenter.longitude,
        )

        console.log('Moví:', movedKm, 'km')

        return movedKm >= lastFilterRadiusKm.current
    }
    const isFiltering = useRef(false)

    const debouncedCheckForRecalculation = debounce((cameraCenter) => {
        console.log('Debounce ejecutado con: ', cameraCenter)

        if (isFiltering.current) {
            console.log('⛔ Ya está filtrando, espero…')
            return
        }

        const mustRecalc = checkIfNeedsRecalculation(cameraCenter)
        console.log('Debe recalcular?', mustRecalc, ' ==> ', lastFilterRadiusKm)

        if (mustRecalc) {
            console.log('✔ Recalculando tiendas…')

            isFiltering.current = true

            filterStoresPerKm(
                cameraCenter.latitude,
                cameraCenter.longitude,
                5,
            ).finally(() => {
                isFiltering.current = false
                lastCenter.current = cameraCenter // ← MUY IMPORTANTE
            })
        } else {
            console.log('❌ No me moví lo suficiente')
        }
    }, 500)

    const getNearestStores = (
        stores,
        userLat,
        userLng,
        {
            initialRadiusKm = 5,
            minStores = 30,
            maxRadiusKm = 10, // máximo que se va a expandir
        },
    ) => {
        let radius = initialRadiusKm
        let candidates = []

        while (radius <= maxRadiusKm) {
            const box = getBoundingBox(userLat, userLng, radius)

            // 1) Prefiltro rápido por bounding box
            candidates = stores.filter(
                (s) =>
                    s.lat >= box.minLat &&
                    s.lat <= box.maxLat &&
                    s.lng >= box.minLng &&
                    s.lng <= box.maxLng,
            )

            if (candidates.length >= minStores) {
                break // 🎉 ya tenemos suficientes
            }

            radius += initialRadiusKm // → expandimos por pasos de 5km
        }

        // 2) Distancia real SOLO sobre los candidatos
        const sorted = candidates
            .map((s) => ({
                ...s,
                distance: haversine(userLat, userLng, s.lat, s.lng),
            }))
            .sort((a, b) => a.distance - b.distance)
        console.log('Tiendas filtradas por regino ==> ', sorted.length)
        lastFilterCenter.current = { lat: userLat, lng: userLng }
        lastFilterRadiusKm.current = radius

        return sorted
    }
    const oneFunc = async () => {
        const camera = await mapRef.current?.getCamera()
        console.log('CAMERA HERE ==>', camera)

        // onCameraIdle(camera)
        await handleCameraChange(camera)
    }
    return (
        <>
            <View style={styles.container}>
                <MapView
                    ref={mapRef}
                    // onRegionChangeComplete={handleCameraChange}
                    onRegionChangeComplete={() => {
                        oneFunc()
                    }}
                    re
                    provider={PROVIDER_GOOGLE}
                    showsUserLocation={true}
                    followsUserLocation={true}
                    loadingEnabled={false}
                    initialCamera={initialCamera}
                    camera={currentStore}
                    style={styles.map}
                >
                    {visibleMarkers.length > 0 &&
                        visibleMarkers.map((marker, index) => {
                            return (
                                <Marker
                                    key={`marker-${marker._id}-${Math.random()}-${index}`}
                                    coordinate={{
                                        latitude: marker.lat,
                                        longitude: marker.lng,
                                    }}
                                    title={marker.name}
                                    pinColor={marker.color}
                                    onPress={(e) => {
                                        let selectedIndex =
                                            regionFilteredStores.findIndex(
                                                (store) => store._id === marker._id,
                                            )

                                        if (selectedIndex !== -1) {
                                            let offset = Math.round(
                                                selectedIndex * deviceWidth,
                                            )
                                            mainViewRef.current?.scrollToOffset({
                                                offset: offset,
                                                animated: false,
                                            })
                                        }
                                    }}
                                />
                            )
                        })}
                </MapView>
            </View>

            {!isLoading && (
                <View style={styles.cardContainer}>
                    <View style={styles.card}>
                        <UpdateLocationIcon
                            iconSize={28}
                            iconColor={theme.colors.colorPrimary}
                            style={{
                                height: 44,
                                width: 44,
                                borderRadius: 12,
                                borderColor: theme.colors.lightGray,
                                borderWidth: 1,
                                backgroundColor: 'white',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginBottom: 12,
                            }}
                            userInfo={{
                                lat: userLat ?? null,
                                lng: userLng ?? null,
                                storeID: currentStoreID ?? null,
                            }}
                            onUpdate={() => {
                                setisLoading(true)
                                setCurrentStore(initialCamera)
                                getStores()
                            }}
                        />
                        <TouchableOpacity
                            style={{
                                height: 44,
                                width: 44,
                                borderRadius: 12,
                                borderColor: theme.colors.lightGray,
                                borderWidth: 1,
                                backgroundColor: 'white',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginBottom: 6,
                            }}
                            onPress={() => setCurrentStore(initialCamera)}
                        >
                            <Image
                                style={{
                                    width: 28,
                                    height: 28,
                                    tintColor: theme.colors.colorPrimary,
                                }}
                                source={require('../../../assets/map_placement.png')}
                            />
                        </TouchableOpacity>
                    </View>
                    <Animated.FlatList
                        ref={mainViewRef}
                        data={regionFilteredStores}
                        windowSize={11}
                        style={styles.flatList}
                        pagingEnabled
                        horizontal={true}
                        getItemLayout={getItemLayout}
                        bounces={false}
                        keyExtractor={(item) => item._id}
                        renderItem={({ item: store, index }) => (
                            <View style={styles.containerStoreItem}>
                                <StoreItem
                                    key={`card-${store._id}-${Math.random()}-${index}`}
                                    store={store}
                                    onClickGoStore={onClickGoStore}
                                />
                            </View>
                        )}
                        showsHorizontalScrollIndicator={false}
                        viewabilityConfig={{
                            waitForInteraction: false,
                            itemVisiblePercentThreshold: 90,
                            minimumViewTime: 1000,
                        }}
                        onViewableItemsChanged={onItemViewedChange}
                        onScrollBeginDrag={() => {
                            // ✅ Bloquear actualizaciones durante el scroll manual
                            // isUpdatingMarkers.current = true
                            // if (updateTimeout.current) {
                            //     clearTimeout(updateTimeout.current)
                            // }
                        }}
                        onScrollEndDrag={() => {
                            // ✅ Permitir actualizaciones después de un breve delay
                            // setTimeout(() => {
                            //     if (!isAnimatingCamera.current) {
                            //         isUpdatingMarkers.current = false
                            //     }
                            // }, 300)
                        }}
                    />
                </View>
            )}
            {isLoading && (
                <Loader
                    style={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: 9999,
                        elevation: 9999,
                    }}
                />
            )}
        </>
    )
}

const calculateBounds = (center, zoom, mapDimensions) => {
    const { width, height } = mapDimensions

    const factor = 2 // Puedes ajustar este valor para ampliar más o menos el rango

    const latDelta = (360 / Math.pow(2, zoom)) * factor
    const lngDelta =
        (latDelta * (width / height)) / Math.cos((center.latitude * Math.PI) / 180)

    return {
        minLat: center.latitude - latDelta / 2,
        maxLat: center.latitude + latDelta / 2,
        minLng: center.longitude - lngDelta / 2,
        maxLng: center.longitude + lngDelta / 2,
    }
}

const isMarkerInBounds = (lat, lng, bounds) => {
    return (
        lat >= bounds.minLat &&
        lat <= bounds.maxLat &&
        lng >= bounds.minLng &&
        lng <= bounds.maxLng
    )
}

const toRad = (v) => (v * Math.PI) / 180

const haversine = (lat1, lon1, lat2, lon2) => {
    const R = 6371 // km
    const dLat = toRad(lat2 - lat1)
    const dLon = toRad(lon2 - lon1)

    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2

    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)))
}

const getBoundingBox = (lat, lng, radiusKm) => {
    const latDelta = radiusKm / 111
    const lngDelta = radiusKm / (111 * Math.cos(toRad(lat)))

    return {
        minLat: lat - latDelta,
        maxLat: lat + latDelta,
        minLng: lng - lngDelta,
        maxLng: lng + lngDelta,
    }
}
